import _ from 'lodash';

// some array helper functions
Object.defineProperty(Array.prototype, 'flatten', {
  value() { return this.reduce((agg, val) => agg.concat(val), []); }
});

Object.defineProperty(Array.prototype, 'extend', {
  value(other) {
    if (_.isArray(other)) {
      for (let x = 0; x < other.length; ++x) {
        this.push(other[x]);
      }
    }
    else {
      this.push(other);
    }
    return this;
  }
});

Object.defineProperty(Array.prototype, 'unique', {
  value() { return _.uniqBy(this, e => _.isRegExp(e) ? e.toString() : e); }
});
